import { emptyArray, emptyString } from "./emptyConst";

export const initialNegotiationState = {
  negotiationChecked: false,
  documentVerificationError: false,
  negotiationReason: emptyString,
  mandatoryRequiredDocuments: null,
  optionalRequiredDocuments: null,
  selectedQuotations: emptyArray,
  negotiationInProgress: false
};

export const quotationsStatus = {
  VALID: "VALID",
  EXPIRED: "EXPIRED",
  PROCESSING: "PROCESSING",
  COMPUTING: "COMPUTING"
};